import { escapeCsvValue, sanitizeUserInput } from "../../../../utils/csvExport.js";

export const UUID_PATTERN =
  /^([0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;

export function normalizeHeader(header: string): string {
  return header.replace(/^﻿/, "").trim().toLowerCase();
}

export function csvField(value: string | number | null): string {
  return escapeCsvValue(sanitizeUserInput(value === null ? null : String(value)));
}

export function filenameStamp(now: Date): string {
  return now.toISOString().slice(0, 19).replace(/[:T]/g, "-");
}
